export const SORT_OPTIONS = [
  { value: "default", label: "Default" },
  { value: "horizon", label: "Horizon" },
  { value: "status", label: "Status" },
  { value: "priority", label: "Priority" },
  { value: "targetPeriod", label: "Target Period" },
];
